import axios from "axios";

// const base_url = "http://18.116.8.181:8080/Thingworx/Things/Test";
// const apiKey = "f1451e09-f452-49e8-934c-43142ffe7039";
const postdata_base_url = "http://54.147.233.200:3001";
const authCode = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MDk2NTc3MDgsImV4cCI6MTc0MTIxNTMwOH0.WEnfLNS7s0V32VVW7z0buZ-y5hgYQvrGSFp5Mi7xeLw";

export const getMachines = async () => {
  try {
    const url = `${postdata_base_url}/pg/machines`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching TWX data:", error);
    throw error;
  }
};

export const getProperties = async () => {
  try {
    const url = `${postdata_base_url}/pg/properties`;
    const headers = {
      authorization: authCode,
    };

    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching TWX data:", error);
    throw error;
  }
};

export const getDataByDate = async (dataByDate) => {
  try {
    const url = `${postdata_base_url}/pg/dataByDate`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.post(url, dataByDate, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching TWX data:", error);
    throw error;
  }
};

export const getDataByTimeRange = async (body) => {
  try {
    const url = `${postdata_base_url}/pg/dataByTimeRange`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching TWX data:", error);
    throw error;
  }
};

export const getAggregatedData = async (aggregatedData) => {
  try {
    const url = `${postdata_base_url}/pg/aggregatedData`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.post(url, aggregatedData, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching TWX data:", error);
    throw error;
  }
};

export const getDashboardData = async () => {
  try {
    const url = `${postdata_base_url}/dashboardstudio/getAllDashboards`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDashboard = async (dashboardName) => {
  try {
    const url = `${postdata_base_url}/dashboardstudio/delete/${dashboardName}`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.delete(url, { headers });
    return response.data;
  } catch (error) {
    console.error(error.response.data.error);
    throw error;
  }
};

export const saveDashboardData = async (body) => {
  try {
    const url = `${postdata_base_url}/dashboardstudio/create`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllWidgetsData = async () => {
  try {
    const url = `${postdata_base_url}/dashboardstudio/getAllWidgets`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const saveWidgetData = async (body) => {
  try {
    const url = `${postdata_base_url}/dashboardstudio/saveWidget`;
    const headers = {
      authorization: authCode,
    };
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};